module.exports = __webpack_public_path__ + "img/Ident-Process-5-mobile.183e0376.png";